/** When your routing table is too long, you can split it into small modules**/

// 素材管理

import Layout from '@/views/layout/Layout'

const mtTargetManage = {
  path: '/mtTargetManage',
  component: Layout,
  alwaysShow: true,
  name: '病害管理',
  redirect: 'noredirect',
  meta: {
    title: '病害管理',
    icon: 'list',
    resources: 'mtTargetManage'
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/detectedTarget/list'),
      name: '病害列表',
      meta: { title: '病害列表', icon: 'excel', noCache: true, resources: 'textTemplateList' }
    }

  ]
}

export default mtTargetManage
